/**
 * All API prefixes created or modified here should reflect in the ERROR_CODES.md documentation.
 *
 * {@link https://github.azc.ext.hp.com/jarvis/react-portal-oobe-mfe/blob/develop/ERROR_CODES.md}
 */

import {
  AccountMgtSvcClient,
  DeviceAuthGrantClient,
} from '@jarvis/web-stratus-client'

/**
 * API prefixes to identify the source of the error.
 * Reserved prefixes:
 *  - `XX` for unexpected errors
 *  - `AP` for App dependencies or internal app errors
 *  - `CS` for Content Stack errors
 *  - `DH` for Device HTTP Proxy errors
 */
export const APIS_CLASS_PREFIX_MAP = [
  [DeviceAuthGrantClient, 'DA'],
  [AccountMgtSvcClient, 'AM'],
] as const satisfies ReadonlyArray<readonly [unknown, string]>
export type ApisClassPrefixMap = typeof APIS_CLASS_PREFIX_MAP
